/**
 * Built using :
 *  ISO3166::Country.all
 *    .select{ |_| _.region == 'Europe' || _.alpha2 == 'US' || _.alpha2 == 'CA' }
 *    .map { |_| [_.alpha2, _.unofficial_names.compact.map(&:downcase).uniq] }
 */
const mostCommonNamePerCountry = [
  ["AD","andorre","andorra","アンドラ"],
  ["AL","albania","albanien","albanie","アルバニア","albanië"],
  ["AT","austria","österreich","autriche","オーストリア","oostenrijk"],
  ["AX","åland islands","åland","オーランド諸島","ålandeilanden"],
  ["BA","bosnia and herzegovina","bosnien und herzegowina","bosnie et herzégovine","bosnia y herzegovina","ボスニア・ヘルツェゴビナ","bosnië en herzegovina","bosnia herzegovina"],
  ["BE","belgium","belgien","belgique","bélgica","ベルギー","belgië"],
  ["BG","bulgaria","bulgarien","bulgarie","ブルガリア","bulgarije"],
  ["BY","belarus","weißrussland","biélorussie","bielorrusia","ベラルーシ","wit-rusland","беларусь"],
  ["CA","canada","kanada","canadá","カナダ"],
  ["CH","switzerland","schweiz","suisse","suiza","スイス","zwitserland"],
  ["CZ","czech republic","tschechische republik","république tchèque","república checa","チェコ","tsjechië","czechia","česká republika"],
  ["DE","germany","deutschland","allemagne","alemania","ドイツ","duitsland"],
  ["DK","denmark","dänemark","danemark","dinamarca","デンマーク","denemarken"],
  ["EE","estonia","estland","estonie","エストニア"],
  ["ES","spain","spanien","espagne","españa","スペイン","spanje"],
  ["FI","finland","finnland","finlande","finlandia","フィンランド"],
  ["FO","faroe islands","färöer-inseln","îles féroé","islas faroe","フェロー諸島","faeröer"],
  ["FR","france","frankreich","the french republic","フランス","frankrijk","francia"],
  ["GB","united kingdom","the united kingdom","england","großbritannien","vereinigtes königreich","royaume-uni","reino unido","イギリス","verenigd koninkrijk","great britain (uk)","uk","великобритания","velká británie","i̇ngiltere","великобританія"],
  ["GG","guernsey and alderney","guernsey und alderney","guernsey et alderney","guernsey y alderney","ガーンジー","guernsey"],
  ["GI","gibraltar","ジブラルタル"],
  ["GR","greece","griechenland","grèce","grecia","ギリシャ","griekenland"],
  ["HR","croatia","kroatien","croatie","croacia","クロアチア","kroatië","croatia (hrvatska)"],
  ["HU","hungary","ungarn","hongrie","hungría","ハンガリー","hongarije"],
  ["IE","ireland","irland","irlande","irlanda","アイルランド","ierland"],
  ["IM","isle of man","insel man","île de man","isla de man","マン島"],
  ["IS","iceland","island","islande","islandia","アイスランド","ijsland"],
  ["IT","italy","italien","italie","italia","イタリア","italië"],
  ["JE","jersey","ジャージー"],
  ["LI","liechtenstein","リヒテンシュタイン"],
  ["LT","lithuania","litauen","lituanie","lituania","リトアニア","litouwen","літва","lietuva"],
  ["LU","luxembourg","luxemburg","luxemburgo","ルクセンブルク"],
  ["LV","latvia","lettland","lettonie","letonia","ラトビア","letland"],
  ["MC","monaco","mónaco","モナコ"],
  ["MD","moldova","moldawien","moldavie","moldavia","the republic of moldova","モルドバ共和国","moldavië"],
  ["ME","crna gora","montenegro","モンテネグロ"],
  ["MK","macedonia","mazedonien","macédoine","f.y.r.o.m (macedonia)","マケドニア旧ユーゴスラビア共和国","macedonië [fyrom]","macedonia (the former yugoslav republic of)","north macedonia","macedonia (fyrom)"],
  ["MT","malta","malte","マルタ"],
  ["NL","netherlands","the netherlands","niederlande","pays-bas","países bajos","オランダ","nederland","нидерландия"],
  ["NO","norway","norwegen","norvège","noruega","ノルウェー","noorwegen"],
  ["PL","poland","polen","pologne","polonia","ポーランド"],
  ["PT","portugal","ポルトガル"],
  ["RO","romania","rumänien","roumanie","rumania","ルーマニア","roemenië"],
  ["RS","serbia","serbien","serbie","セルビア","servië"],
  ["RU","russia","russland","russie","rusia","ロシア連邦","rusland","россия","расія"],
  ["SE","sweden","schweden","suède","suecia","スウェーデン","zweden"],
  ["SI","slovenia","slowenien","slovénie","eslovenia","スロベニア","slovenië"],
  ["SJ","svalbard and jan mayen","svalbard und jan mayen","îles svalbard et jan mayen","islas svalbard y jan mayen","スヴァールバル諸島およびヤンマイエン島","svalbard en jan mayen"],
  ["SK","slovakia","slowakei","slovaquie","república eslovaca","スロバキア","slowakije"],
  ["SM","san marino","saint-marin","サンマリノ"],
  ["UA","ukraine","ucrania","ウクライナ","oekraïne","украина","україна","украіна"],
  ["US","united states","usa","vereinigte staaten von amerika","états-unis","estados unidos","アメリカ合衆国","verenigde staten","соединенные штаты америки"],
  ["VA","vatican city","vatikan","cité du vatican","ciudad del vaticano","バチカン市国","vaticaanstad","vatican city state (holy see)"]
]

const mostCommonNamePerNationality = [
  ["FR", "française"]
]

export function countryIsFrance (country: string) {
  return ['FR', 'RE', 'GP', 'MQ', 'YT', 'GF', 'NC'].includes(country)
}

/**
 * Receive an input like 'France', 'FR', 'france', 'FRANCE' and cast it to 'FR'.
 * Returns `null` if the input cannot be casted.
 */
export function inferCountryCodeFromInput (country: string) {
  if (country.length == 2) return country.toUpperCase()
  country = country.toLowerCase()

  for (const [countryCode, ...names] of mostCommonNamePerCountry) {
    if (names.includes(country)) return countryCode
  }

  return null
}

export function inferNationalityByInput (nationality: string) {
  if (nationality.length == 2) return nationality.toUpperCase()
  nationality = nationality.toLowerCase()

  for (const [countryCode, ...names] of mostCommonNamePerNationality) {
    if (names.includes(nationality)) return countryCode
  }

  return null
}
